import * as React from "react";
import {
  BannerImg,
  BannerLink,
  BannerWrap,
  DownloadWrap,
  HeroContent,
  HeroDescription,
  HeroH1,
  HeroHeadingWrap,
  HeroImageWrap,
  HeroWrap,
  Image,
  Overheading,
  TestimonialIconWrap,
  Testimonials,
  TestimonialText,
  TestimonialWrap,
  ThreeColumn,
  ThreeColumns,
  TwoColumn,
  TwoColumns,
} from "./hero.style";

import appStoreBanner from "../assets/app-store-badge.png";
import googlePlayBanner from "../assets/google-play-badge.png";
import heroImage from "../assets/hero-image.png";
import testimonialIcon from "../assets/testimonial-icon.png";

const HeroComponent = () => {
  return (
    <>
      <TwoColumns>
        <TwoColumn>
          <HeroWrap>
            <HeroContent>
              <Overheading>dein mobiles Magazin</Overheading>
              <HeroHeadingWrap>
                <HeroH1>
                  Entdecke die KATAPULT-App mit den neuesten Nachrichten und
                  spannenden Artikeln!
                </HeroH1>
                <HeroDescription>
                  Mit dieser App hast du Zugriff auf alle Inhalte von
                  KATAPULT-Magazin, KATAPULT-MV und KATAPULT-Ukraine, sodass du
                  stets gut informiert bist und die neuesten Nachrichten,
                  spannende Artikel und aufschlussreiche Grafiken immer zur Hand
                  hast.
                </HeroDescription>
              </HeroHeadingWrap>
            </HeroContent>
            <DownloadWrap>
              <BannerWrap>
                <BannerLink href="https://apps.apple.com/de/app/katapult-dein-mobiles-magazin/id1619326983?itsct=apps_box_link&itscg=30200">
                  <BannerImg
                    src={appStoreBanner}
                    alt="Apple App Store banner"
                  />
                </BannerLink>
              </BannerWrap>
              <BannerWrap>
                <BannerLink href="https://play.google.com/store/apps/details?id=com.katapult_magazin.katapult_app">
                  <BannerImg
                    src={googlePlayBanner}
                    alt="Google Play Store banner"
                  />
                </BannerLink>
              </BannerWrap>
            </DownloadWrap>
          </HeroWrap>
        </TwoColumn>
        <TwoColumn>
          <HeroImageWrap>
            <Image src={heroImage} alt="Hero Image" />
          </HeroImageWrap>
        </TwoColumn>
      </TwoColumns>
      <Testimonials>
        <ThreeColumns>
          <ThreeColumn>
            <TestimonialWrap>
              <TestimonialIconWrap>
                <Image src={testimonialIcon} alt="Testimonial Icon" />
              </TestimonialIconWrap>
              <TestimonialText>
                Tolle Idee Katapult in der App-Version
              </TestimonialText>
            </TestimonialWrap>
          </ThreeColumn>
          <ThreeColumn>
            <TestimonialWrap>
              <TestimonialIconWrap>
                <Image src={testimonialIcon} alt="Testimonial Icon" />
              </TestimonialIconWrap>
              <TestimonialText>Genial</TestimonialText>
            </TestimonialWrap>
          </ThreeColumn>
          <ThreeColumn>
            <TestimonialWrap>
              <TestimonialIconWrap>
                <Image src={testimonialIcon} alt="Testimonial Icon" />
              </TestimonialIconWrap>
              <TestimonialText>
                Beste App seit dem es Eis gibt ;-)
              </TestimonialText>
            </TestimonialWrap>
          </ThreeColumn>
        </ThreeColumns>
      </Testimonials>
    </>
  );
};

export default HeroComponent;
